import { NgModule } from '@angular/core';
import { MaterialModule } from '../core/material.module';
import { SharedModule } from '../core/shared.module';
import { LawyerlyChipListComponent } from './chip-list/lawyerly-chip-list.component';
import { CardLoaderComponent } from './loaders/card-loader/card-loader.component';
import { MiniLoaderComponent } from './loaders/mini-loader/mini-loader.component';
import { SpinnerLoaderComponent } from './loaders/spinner-loader/spinner-loader.component';
import { FilterCustomInputMaterialComponent } from './material/filter-custom-input-material/filter-custom-input-material.component';
import { TestEnvBannerComponent } from './test-env-banner/test-env-banner.component';
import { UserAvatarComponent } from './user-avatar/user-avatar.component';

@NgModule({
    declarations: [
        TestEnvBannerComponent,
        SpinnerLoaderComponent,
        CardLoaderComponent,
        LawyerlyChipListComponent,
        FilterCustomInputMaterialComponent,
        UserAvatarComponent,
        MiniLoaderComponent
    ],
    imports: [MaterialModule, SharedModule],
    providers: [],
    exports: [
        TestEnvBannerComponent,
        SpinnerLoaderComponent,
        CardLoaderComponent,
        LawyerlyChipListComponent,
        FilterCustomInputMaterialComponent,
        UserAvatarComponent,
        MiniLoaderComponent
    ],
    bootstrap: []
})
export class UtilityModule {}
